import type { SVGProps } from 'react';

export const InputRadio = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height="32px"
    role="img"
    viewBox="0 0 32 32"
    width="32px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{'input radio'}</title>
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <circle cx="16" cy="16" fill="#F2F4F9" r="16" />
      <g transform="translate(4, 4)">
        <circle cx="12" cy="12" r="11.5" stroke="#898C9A" />
        <path
          d="M11.1939556,16.4477333 C11.0055111,16.4477333 10.8241778,16.3730667 10.6908444,16.2388444 L7.06862222,12.8308444 C6.93528889,12.6975111 6.86062222,12.5170667 6.86062222,12.3277333 C6.86062222,12.1384 6.93528889,11.9579556 7.06862222,11.8255111 L7.57262222,11.3224 C7.71128889,11.1837333 7.89262222,11.1144 8.07484444,11.1144 C8.25706667,11.1144 8.4384,11.1837333 8.57795556,11.3224 L11.1939556,13.7810667 L15.8099556,8.98906667 C15.9432889,8.85573333 16.1246222,8.78106667 16.3130667,8.78106667 L16.3130667,8.78106667 C16.5015111,8.78106667 16.6828444,8.85573333 16.8161778,8.98906667 L17.3192889,9.49128889 C17.5966222,9.76951111 17.5966222,10.2201778 17.3192889,10.4975111 L11.6970667,16.2388444 C11.5637333,16.3730667 11.3824,16.4477333 11.1939556,16.4477333"
          fill="#898C9A"
        />
      </g>
    </g>
  </svg>
);
